document.addEventListener("DOMContentLoaded", (event) => {
  /*
  * PkConfigStep, config use to the store
  */
  class PkConfigStep extends HTMLElement {
    constructor() {
      super();
      this.store = document.querySelector('pk-store');
      
      // Subscribe to store updates if the store and subscribe method are available
      if (this.store && this.store.subscribe) {
        this.store.subscribe(this.render.bind(this));
      } else {
        console.error('PkStore element not found or subscribe method is not available.');
      }
    }

    connectedCallback() {
      if (this.store) {
        this.render(this.store.state);
      }
    }

    // Renders the component based on the current state
    render(state) {
      const currentStepElement = this.querySelector('[data-id="pk-current-step"]');
      
      if (currentStepElement) {
        currentStepElement.textContent = `${state.currentStep}/5`;
      }
      this.showCurrentStep(state.currentStep);
    }

    // Displays the appropriate step based on the current step number
    showCurrentStep(step) {
      const steps = this.querySelectorAll('pk-method-step, pk-flavour-step, pk-sensory-step, pk-properties-step, pk-overview-step');
      
      steps.forEach((stepEl, index) => {
        stepEl.style.display = index + 1 === step ? 'block' : 'none';
      });
    }
  }

  customElements.define('pk-config-step', PkConfigStep);
});
